import React from 'react'
import './styles/timesheet.css'
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import IconButton from '@mui/material/IconButton';

export default class TimeSheet extends React.Component {
    render() {
        return (
            <div className="timesheet">
                <div className="timesheet-accent" />
                <div className="timesheet-content">
                    <div className="timesheet-entry-row">
                        {!this.props.user.comp_settings.some(item => item.feature_value === "primaryBusinessType" && item.feature_id === 101) &&
                            <p className="timesheet-date">{moment(this.props.data.start_time).utc().format('DD MMM, hh:mm A')} - {moment(this.props.data.end_time).utc().format('DD MMM, hh:mm A')}</p>
                        }
                        {this.props.user.comp_settings.some(item => item.feature_value === "primaryBusinessType" && item.feature_id === 101) &&
                            <p className="timesheet-date">{moment(this.props.data.start_time).utc().format('DD MMM')}</p>
                        }
                        <div className="timesheet-entry-actions">
                            <p className="timesheet-hours">{moment.duration(moment(this.props.data.start_time).diff(moment(this.props.data.end_time))).humanize({ m: 1000 })}</p>
                            <IconButton aria-label="Edit timesheet entry" title="Edit timesheet entry" onClick={() => { this.props.onEdit(this.props.data.id) }} className="timesheet-edit-button" fontSize="small">
                                <EditIcon />
                            </IconButton>
                        </div>
                    </div>
                    <div className="timesheet-entry-row timesheet-second-row">
                        <p className="timesheet-task-title">{(!!this.props.data.taskDets && !!this.props.data.locDets) ? this.props.data.taskDets.tas_title : (!this.props.data.locDets && !!this.props.data.taskDets) ? this.props.data.taskDets.tas_title.length < 20 ? `${this.props.data.taskDets.tas_title} - Call Record` : `${this.props.data.taskDets.tas_title.substr(0, 20)}... - Call Record` : 'Call Record'}</p>
                        <span className="timesheet-task-type">{this.props.data.taskDets?.tas_type || 'No task type'}</span>
                    </div>
                    <div className="timesheet-entry-row timesheet-project-row">
                        <p className="timesheet-project">{!!this.props.data.projDets ? 'Project: ' + this.props.data.projDets.pro_title : 'Project unavailable'}</p>
                        {this.props.data.task_form && <IconButton aria-label="View task form" title="View task form" onClick={() => this.props.setCurrentTask(this.props.data)} className="timesheet-form-button" fontSize="small">
                            <FormatListBulletedIcon />
                        </IconButton>}
                    </div>
                </div>
            </div>
        )
    }
}
